import { useSelector } from "react-redux";
import { MODULE_KEY } from "./ecomOrders-actions";
import { ACTION } from "../../util/utils";
import Button from "../common/Button/Button";
import { EditOutlined, Visibility } from "@mui/icons-material";

export default function filterColumns(
  // Removed editDrawer and viewDrawer
) {
  const { data, loading } = useSelector(
    (state: any) => state[`${MODULE_KEY}${ACTION.STATE_KEY}`]
  );

  const shipToPatientOptions: any[] = [];
  const methodOptions: any[] = [];
  const stateOptions: any[] = [];
  const pickerNameOptions: any[] = [];

  data?.map((row: any) => {
    shipToPatientOptions.push({ text: row.ShipToPatient, value: row.ShipToPatient });
    methodOptions.push({ text: row.Method, value: row.Method });
    stateOptions.push({ text: row.State, value: row.State });
    pickerNameOptions.push({ text: row.PickerName, value: row.PickerName });
  });

  const uniqueFilter = (arr: any[]) =>
    arr.filter(
      (ele: any, ind: any) =>
        ind ===
        arr.findIndex(
          (elem: any) => elem.text === ele.text && elem.text !== "" && elem.text != null
        )
    );

  let methodFilter = uniqueFilter(methodOptions);
  let pickerNameFilter = uniqueFilter(pickerNameOptions);

  const columns = [
    {
      header: "Picker Name",
      accessorKey: "PickerName",
      size: 100,
      enableColumnFilter: true,
      enableSorting: true,
      filterVariant: "multi-select",
      filterSelectOptions: pickerNameFilter,
    },
    {
      header: "Patient Name",
      accessorKey: "PatientName",
      size: 120,
      enableColumnFilter: true,
      filterFn: "contains",
      enableSorting: true,
    },
      {
        header: "Item Name",
        accessorKey: "ItemName",
        size: 200,
        enableColumnFilter: true,
        filterFn: "contains",
        enableSorting: true,
      },
      {
        header: "Item Group",
        accessorKey: "ItemGroup",
        size: 90,
        enableColumnFilter: true,
        filterFn: "contains",
        enableSorting: true,
      },
    {
      header: "UPC",
      accessorKey: "Upc",
      size: 110,
      enableColumnFilter: true,
      enableSorting: true,
      filterFn: "contains",
    },
     {
      header: "Quantity",
      accessorKey: "Quantity",
      size: 60,
      enableColumnFilter: false,
      enableSorting: false,
    },
    {
      header: "Ecom Order Id",
      accessorKey: "OrderId",
      size: 230,
      enableColumnFilter: true,
      filterFn: "contains",
      enableSorting: true,
    },
    {
      header: "Item Id",
      accessorKey: "ItemId",
      size: 220,
      enableColumnFilter: true,
      filterFn: "contains",
      enableSorting: true,
    },
      {
      header: "External Id",
      accessorKey: "ExternalId",
      size: 100,
      enableColumnFilter: true,
      filterFn: "contains",
      enableSorting: true,
    },
    {
      header: "Phone Number",
      accessorKey: "PhoneNumber",
      size: 120,
      enableColumnFilter: true,
      filterFn: "contains",
      enableSorting: true,
    },
    {
      header: "Address",
      accessorKey: "Address",
      size: 250,
      enableColumnFilter: false,
      enableSorting: false,
      Cell: ({ row }: { row: any }) => {
        const r = row.original;
        const address = [r.AddressLine1, r.AddressLine2, r.City, r.State, r.Zip]
          .filter(Boolean)
          .join(", ");
        return address || "N/A";
      },
    },
  ];

  return { columns, data, loading };
}
